import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSetting, setSetting, settingKeys } from '../utils/settings';
import en from './locales/en.json';
import es from './locales/es.json';

export const DEFAULT_LANGUAGE = 'en';

// Named in their own language, so someone who can't read the current one can still find theirs
export const LANGUAGES = [
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Español' },
];

export const isSupported = (id) => LANGUAGES.some((language) => language.id === id);

/** The language picked in Settings, else the first of the browser's we have, else English. */
export const detectLanguage = () => {
  const chosen = getSetting(settingKeys.language);
  if (isSupported(chosen)) return chosen;

  const browserLanguages = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || [];
  // 'es-MX' and 'es-419' are both 'es' here
  const match = browserLanguages
    .map((tag) =>
      String(tag || '')
        .split('-')[0]
        .toLowerCase(),
    )
    .find(isSupported);

  return match || DEFAULT_LANGUAGE;
};

const syncDocumentLanguage = (language) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language;
};

/** Switches the app's language and keeps a copy on this device, for the next start and when signed out. */
export const setLanguage = (language) => {
  const next = isSupported(language) ? language : DEFAULT_LANGUAGE;
  setSetting(settingKeys.language, next);
  return i18n.changeLanguage(next);
};

i18n.on('languageChanged', syncDocumentLanguage);

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: detectLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: LANGUAGES.map((language) => language.id),
  // React escapes what it renders already
  interpolation: { escapeValue: false },
  // Resources are bundled, so there's nothing to wait for: t() works from the first render
  initImmediate: false,
  returnNull: false,
});

syncDocumentLanguage(i18n.language);

export default i18n;
